<template>
    <div id="app">
      <div id="content">
        <Header
          :page="type"
          :title_one="'matches'"
          :action_one="''"
        ></Header>
        <div class="section-title">
            {{ $t('miccamps.matches.nexts') }}
        </div>
        <div v-if="next_matches.length > 0" class="matches-container">
            <Match v-for="match in next_matches" :key="match.id" :item="match" />
        </div>
        <span v-else>{{ $t('miclive.live.empty') }}</span>

        <div class="section-title">
            {{ $t('miccamps.matches.pasts') }}
        </div>
        <div v-if="pasts_matches.length > 0" class="matches-container">
            <Match  v-for="match in pasts_matches" :key="match.id" :item="match" />
        </div>
        <span v-else>{{ $t('miclive.live.empty') }}</span>
      </div>
    </div>
  </template>
<script>
import Header from '@/components/layout/Header'
import Match from '@/components/ui/Match'

export default {
  name: 'Matches',
  components: {
    Header,
    Match
  },
  data () {
    return {
      team: {},
      next_matches: [],
      pasts_matches: [],
      type: '',
      estimate: '',
      estimate_minimum: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  methods: {
    load () {
      var self = this
      this.$overlay.show()
      // save type
      this.type = this.$route.name
      // admin load club info
      if (this.user.admin) {
        this.$store
          .dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function () {})
      }
      // load information
      this.$store
        .dispatch('team/loadMatchesTeam', { event_id: this.user.event_id, team_id: this.$route.params.team_id })
        .then(response => {
          let matches = response
          matches.forEach(match => {
            if (parseInt(match.status) < 9) {
              this.next_matches.push(match)
            } else {
              this.pasts_matches.push(match)
            }
          })

          self.$overlay.hide()
        })
    },
    remove (id) {
      for (var person in this.persons) {
        if (this.persons[person].id === id) {
          this.persons.splice(person, 1)
        }
      }
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'load'
  },
  created () {
    this.load()
  }
}
</script>
  <style scoped>
  .section-title {
        font-weight: bold;
        font-size: 20px;
        margin-top: 20px;
    }
  .matches-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 350px));
    gap: 1rem;
    justify-content: center;
    padding: 1rem;
  }

  @media (max-width: 768px) {
    .matches-container {
        grid-template-columns: 1fr;
        max-width: 350px;
        margin: 0 auto;
    }
  }
  </style>
